import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import { useAppSelector } from "store";
import { motion } from "framer-motion";
import Logo from "components/logo";
import { useSite } from "hooks/use-site";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";

const SuccessRegistration = () => {
  const { logo, frontWalletAuthPageColor } = useSite();
  const navigate = useNavigate();
  const newUser = useAppSelector((state) => state.register.newUser);
  const { t } = useTranslation();

  if (!newUser) {
    navigate("/signin");
  }

  return (
    <Box
      display={"flex"}
      alignItems="center"
      justifyContent="cente"
      height={"100vh"}
    >
      <Container maxWidth="sm">
        <Card elevation={24} component={motion.div} layoutId="auth-card">
          <Box
            paddingY={2.5}
            paddingX={4}
            sx={{ bgcolor: `${frontWalletAuthPageColor}` }}
          >
            <Logo src={logo} />
          </Box>
          <CardContent>
            <Stack spacing={4}>
              <Typography variant="subtitle1">
                {t("auth.success_registration.message", {
                  email: newUser ? newUser.email : "a@b.com",
                })}
              </Typography>
              <Stack spacing={2}>
                <Box display="flex">
                  <LoadingButton
                    onClick={() => navigate("/signin")}
                    fullWidth
                    variant="contained"
                  >
                    {t("auth.success_registration.button")}
                  </LoadingButton>
                </Box>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};
export default SuccessRegistration;
